import React, { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
  Pagination,
} from "react-bootstrap";
import { BsPlus, BsX, BsSend, BsPrinter } from "react-icons/bs";
import { FaTrash, FaCloudDownloadAlt, FaCloudUploadAlt } from "react-icons/fa";
import AdminScreenHeader from "../admin/adminScreenHeader";
import "../../css/client/form24Q.css";
import { apiPost } from "../../service/admin/apiService";
import Loader from "../loader";
import { showError, showSuccess } from "../../utils/toast";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  form27EQFields,
  getPreviousMonthAndFY,
  isDataSentToCA,
  isDataReviewByCA,
} from "../../utils/client/misc";
import Form27EQTable from "./form27EQTable";
import ExportToExceljs from "../../utils/exportToExcel";
import DateFilters from "./dateFilters";
import ChallanDetail from "./challanDetail";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Form27EQ = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [formFinancialYear, setFormFinancialYear] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [form27EQInfo, setForm27EQInfo] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copyDataloading, setCopyDataLoading] = useState(false);
  const [submitToCALoading, setsubmitToCALoading] = useState(false);
  const [isDataSendToCA, setIsDataSendToCA] = useState(false);
  const [isDataReviewedByCA, setIsDataReviewedByCA] = useState(false);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [showChallanInfo, setShowChallanInfo] = useState(false);
  const [challanAmount, setChallanAmount] = useState(0);
  const [uploadingEmpLoading, setUploadingEmpLoading] = useState(false);
  const [downloadingEmpLoading, setDownloadingEmpLoading] = useState(false);
  const [empIds, setEmpIds] = useState([]);
  const navigate = useNavigate();

  const closeModal = () => setShowModal(false);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const filtered27EQInfo = form27EQInfo.filter((info) => {
    const fullName = `${info?.na}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return info?.na.toLowerCase().includes(term) || fullName.includes(term);
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filtered27EQInfo.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filtered27EQInfo, limit]);

  const initialState = Object.fromEntries(
    form27EQFields.map((f) => [f.key, ""])
  );
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (form27EQInfo.length > 0 && isDataSentToCA(form27EQInfo) === true) {
      setIsDataSendToCA(true);
    } else {
      setIsDataSendToCA(false);
    }
    if (form27EQInfo.length > 0 && isDataReviewByCA(form27EQInfo) === true) {
      setIsDataReviewedByCA(true);
    } else {
      setIsDataReviewedByCA(false);
    }
  }, [form27EQInfo]);

  useEffect(() => {
    setEmpIds([]);
  }, [selectedYear, selectedQuarter, selectedMonth]);

  const deleteEmployee = async (empId) => {
    if (isDataSendToCA) return;
    if (empId === 0) {
      showError("You have not selected any employee to delete");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    // if (result.isConfirmed) {
    //   try {
    //     const payload = {
    //       action: "formdelete",
    //       ty: "form27eq",
    //       to: clientInfo?.tk,
    //       id: empId,
    //     };
    //     const response = await apiPost(process.env.REACT_APP_API_URL, payload);
    //     if (Number(response?.errordetails?.errorcode) > 0) {
    //       showError(response?.errordetails?.error);
    //     } else if (response?.responsedetails) {
    //       showSuccess("Employee delete successfully!!!");
    //       get27EQInfo();
    //     }
    //   } catch (err) {
    //     console.error("Error:", err);
    //     showError("Something went wrong");
    //   }
    // }

    if (result.isConfirmed) {
      try {
        const results = await Promise.allSettled(
          empIds.map((empId) =>
            apiPost(process.env.REACT_APP_API_URL, {
              action: "formdelete",
              ty: "form27eq",
              to: clientInfo?.tk,
              id: empId,
            })
          )
        );
        let processed = 0;
        results.forEach((result, index) => {
          processed++;
          if (result.status === "fulfilled") {
            if (processed === results.length) {
              showSuccess(`Employee delete successfully!!!`);
              setEmpIds([]);
              get27EQInfo();
            }
          } else {
            console.error(`Failed to delete ID ${index}`, result.reason);
            showError(`Failed to delete ID ${index}`, result.reason);
            // showError(result?.errordetails?.error);
            return;
          }
        });
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      }
    }
  };

  const get27EQInfo = async () => {
    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (selectedFYearId <= 0) {
        showError("Please select financial year to proceed");
        return;
      }

      if (selectedQuarter === "") {
        showError("Please select quarter to proceed");
        return;
      }

      if (selectedMonth === "") {
        showError("Please select month to proceed");
        return;
      }

      setShowLoader(true);
      const payload = {
        action: "formlist",
        to: clientInfo?.tk,
        ty: "form27eq",
        fi: selectedFYearId,
        mn: selectedMonth,
        //clid: clientInfo.client?.id,
      };

      console.log("payload", payload);

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("response", response?.responsedetails);
          setForm27EQInfo(response?.responsedetails || []);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const handleAdd = () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }
    setShowModal(true);
    setEditingIndex(null);
    setLoading(false);
    setFormData(initialState);
  };

  const handleEdit = (selectedInfo) => {
    if (isDataSendToCA) return;
    setFormData({
      na: selectedInfo["na"],
      pa: selectedInfo["pa"],
      ad: selectedInfo["ad"],
      pi: selectedInfo["pi"],
      np: selectedInfo["np"],
      ap: selectedInfo["ap"],
      apd: selectedInfo["apd"],
      rt: selectedInfo["rt"],
      ta: selectedInfo["ta"],
      it: selectedInfo["it"],
      tt: selectedInfo["tt"],
      cn: selectedInfo["cn"],
      tdbn: selectedInfo["tdbn"],
      // bc: selectedInfo["bc"],
      // chno: selectedInfo["chno"],
      // chdt: selectedInfo["chdt"],
      id: selectedInfo["id"],
    });
    const index = form27EQInfo.findIndex((el) => el.id === selectedInfo["id"]);
    setEditingIndex(index);
    setLoading(false);
    setShowModal(true);
  };

  const downloadTemplateFile = async () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    try {
      //Write excel download logic
      const fileName = "Upload_Partys_Template.xlsx";
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template");

      // Define headers
      worksheet.columns = [
        { header: "Sr.No", key: "Sr.No", width: 10 },
        { header: "Name", key: "Name", width: 30 },
        { header: "Pan", key: "Pan", width: 20 },
      ];

      // Add empty rows (optional)
      for (let i = 0; i < 5; i++) {
        worksheet.addRow({ name: "", age: "", email: "", phone: "" });
      }

      // Style header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).alignment = { horizontal: "center" };

      // Generate buffer and save
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);

      return;
    } catch (err) {
      console.error("Error:", err);
      showError("Something went wrong");
    }
  };

  const uploadTemplateFile = async () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    document.getElementById("fileInput").click();
  };

  // const showFileDialog = async () => {
  //   if (selectedFYearId <= 0) {
  //     showError("Please select financial year to proceed");
  //     return;
  //   }

  //   if (selectedQuarter === "") {
  //     showError("Please select quarter to proceed");
  //     return;
  //   }

  //   if (selectedMonth === "") {
  //     showError("Please select month to proceed");
  //     return;
  //   }

  //   const result = await Swal.fire({
  //     title: "Download Sample File!",
  //     text: "Do you want to download a sample file for upload?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Download!",
  //     width: "320px",
  //     customClass: {
  //       popup: "custom-swal-popup",
  //       confirmButton: "btn btn-sm btn-success",
  //       cancelButton: "btn btn-sm btn-secondary",
  //     },
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       //Write excel download logic
  //       const fileName = "Upload_Partys_Template.xlsx";
  //       const workbook = new ExcelJS.Workbook();
  //       const worksheet = workbook.addWorksheet("Template");

  //       // Define headers
  //       worksheet.columns = [
  //         { header: "Sr.No", key: "Sr.No", width: 10 },
  //         { header: "Name", key: "Name", width: 30 },
  //         { header: "Pan", key: "Pan", width: 20 },
  //       ];

  //       // Add empty rows (optional)
  //       for (let i = 0; i < 5; i++) {
  //         worksheet.addRow({ name: "", age: "", email: "", phone: "" });
  //       }

  //       // Style header row
  //       worksheet.getRow(1).font = { bold: true };
  //       worksheet.getRow(1).alignment = { horizontal: "center" };

  //       // Generate buffer and save
  //       const buffer = await workbook.xlsx.writeBuffer();
  //       const blob = new Blob([buffer], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       saveAs(blob, fileName);

  //       return;
  //     } catch (err) {
  //       console.error("Error:", err);
  //       showError("Something went wrong");
  //     }
  //   }
  //   document.getElementById("fileInput").click();
  // };

  const handleFileUpload = async (event) => {
    let file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".xlsx")) {
      showError("Only .xlsx files are allowed.");
      return;
    }

    try {
      const buffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(buffer);

      const worksheet = workbook.worksheets[0];
      const firstRow = worksheet.getRow(1).values;

      if (
        firstRow[1] !== "Sr.No" ||
        firstRow[2] !== "Name" ||
        firstRow[3] !== "Pan"
      ) {
        showError(
          "Excel must have three columns as 'Sr.No' and 'Name' and 'Pan' in first row"
        );
        event.target.value = "";
        return;
      }
      setUploadingEmpLoading(true);

      for (let i = 2; i <= worksheet.rowCount; i++) {
        const row = worksheet.getRow(i);
        const name = row.getCell(2).value;
        const pan = row.getCell(3).value;

        if (name && pan) {
          // formData["na"] = name;
          formData["na"] = name
            .replace(
              /\b(Mr|Mrs|Ms|Miss|Shri|Shree|Dr|Prof|Sir|Madam|Mx)\b\.?\s*/gi,
              ""
            )
            .replace(/\b(Jr|Sr|MD|PhD|DDS|Esq|II|III|IV|V)\b\.?\s*/gi, "")
            .trim()
            .replace(/\s{2,}/g, " ");
          formData["pa"] = pan.toUpperCase();

          const payload = {
            action: "formadd",
            to: clientInfo?.tk,
            ty: "form27eq",
            fi: selectedFYearId,
            mn: selectedMonth,
            na: formData["na"],
            pa: formData["pa"],
            ad: formData["ad"],
            pi: formData["pi"],
            np: formData["np"],
            ap: formData["ap"],
            apd: formData["apd"],
            rt: formData["rt"],
            ta: formData["ta"],
            it: formData["it"],
            tt: formData["tt"],
            cn: formData["cn"],
            tdbn: formData["tdbn"],
          };

          try {
            const response = await apiPost(
              process.env.REACT_APP_API_URL,
              payload
            );
            console.log("res", response);
          } catch (err) {
            console.error("Error:", err);
            console.log("error in payload", name, pan);
          }
        }
      }
      showSuccess("Uploading Done...");
      setUploadingEmpLoading(false);
      event.target.value = "";
      get27EQInfo();
    } catch (err) {
      console.error(err);
      setUploadingEmpLoading(false);
      event.target.value = "";
      showError("Failed to read Excel file.");
    }
  };

  const save27EQInfo = async (transType) => {
    if (loading) return;

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (formData["en"] === "") {
        showError("Please enter employee name to proceed");
        return;
      }

      if (formData["pa"] === "") {
        showError("Please enter employee pan number to proceed");
        return;
      }

      setLoading(true);

      const payload = {
        action: transType === "addInfo" ? "formadd" : "formupdate",
        to: clientInfo?.tk,
        ty: "form27eq",
        fi: selectedFYearId,
        mn: selectedMonth,
        na: formData["na"],
        pa: formData["pa"],
        ad: formData["ad"],
        pi: formData["pi"],
        np: formData["np"],
        ap: formData["ap"],
        apd: formData["apd"],
        rt: formData["rt"],
        ta: formData["ta"],
        it: formData["it"],
        tt: formData["tt"],
        cn: formData["cn"],
        tdbn: formData["tdbn"],
        // bc: formData["bc"],
        // chno: formData["chno"],
        // chdt: formData["chdt"],
        ...(transType === "updateInfo" && { id: formData["id"] }),
      };

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setLoading(false);
        } else if (response?.responsedetails.success === "yes") {
          console.log("response", response?.responsedetails);
          setTimeout(() => {
            setLoading(false);
            if (transType === "updateInfo") {
              showSuccess("Selected employee updated successfully!!!");
            } else {
              showSuccess("Employee created successfully!!!");
            }
            setShowModal(false);
            get27EQInfo();
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const getLastMonthData = async () => {
    if (copyDataloading) return;

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    setCopyDataLoading(true);

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      const lastFy = await getPreviousMonthAndFY(
        selectedYear,
        selectedMonth,
        formFinancialYear
      );

      if (lastFy) {
        setLoading(true);
        const payload = {
          action: "copyformdata",
          to: clientInfo?.tk,
          ty: "form27eq",
          ffi: lastFy.financialYearId,
          fmo1: lastFy.month,
          fi: selectedFYearId,
          mo1: selectedMonth,
        };
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );

          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setCopyDataLoading(false);
          } else if (response?.responsedetails.success === "yes") {
            console.log("response123", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              if (response?.responsedetails?.c1 === 0) {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("No last month data found.");
                }, 3000);
              } else {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("Data copied successfully to selected month");
                  get27EQInfo();
                }, 3000);
              }
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setCopyDataLoading(false);
        }
      }
    }
  };

  const submitToCA = async () => {
    if (form27EQInfo.length <= 0) {
      showError("There is no such information to proceed");
      return;
    }

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will freeze the information. Please verify information before proceeding",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      if (submitToCALoading) return;

      setsubmitToCALoading(true);

      const payload = {
        action: "formsubmit",
        to: clientInfo?.tk,
        ty: "form27eq",
        fi: selectedFYearId,
        mn: selectedMonth,
        ae: "no",
      };

      if (clientInfo?.tk && clientInfo?.tk !== "") {
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );

          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setsubmitToCALoading(false);
          } else if (response?.responsedetails) {
            console.log("response", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              setTimeout(() => {
                setsubmitToCALoading(false);
                showSuccess("Selected month info submit to CA successfully!!!");
                get27EQInfo();
              }, 3000);
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setsubmitToCALoading(false);
        }
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  const showChallan = () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    if (form27EQInfo.length <= 0) {
      showError("Please add employee detail to proceed");
      return;
    }

    const totalIt = form27EQInfo.reduce(
      (sum, item) => sum + (parseFloat(item.tt) || 0),
      0
    );
    setChallanAmount(totalIt);
    setShowChallanInfo(true);
  };

  const hideChallan = () => {
    setShowChallanInfo(false);
  };

  const uploadEmployees = () => {};

  const handelPrintEmpReport = () => {
    navigate("/print-emp-report");
  };

  return (
    <Container fluid className="p-md-4 form24q-container">
      <div className="mt-3">
        <AdminScreenHeader
          title="📋 Form 27EQ"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search Employee..."
          showSearch={true}
        />

        {/* Dropdowns */}
        <DateFilters
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedQuarter={selectedQuarter}
          setSelectedQuarter={setSelectedQuarter}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          getFormInfo={get27EQInfo}
          setSelectedFYearId={setSelectedFYearId}
          setFormInfo={setForm27EQInfo}
          setFormFinancialYear={setFormFinancialYear}
        />

        {form27EQInfo.length > 0 &&
          (isDataReviewedByCA ? (
            <div className="data-send-to-ca">
              This information has already been reviewed by the CA.
            </div>
          ) : isDataSendToCA ? (
            <div className="data-send-to-ca">
              This information has been sent to the CA for review.
            </div>
          ) : null)}
        <div
          // style={{
          //   display: "flex",
          //   justifyContent: "flex-end",
          //   marginBottom: "5px",
          //   marginTop: "-10px",
          //   paddingRight: "15px",
          // }}
          className="grid-button-container"
        >
          {/* <ExportToExceljs
            data={filtered27EQInfo}
            fileName={`Form27EQ_${selectedYear}_${selectedMonth}`}
            formName="form27eq"
            clientName={clientInfo.client?.cn}
            clientTan={clientInfo.client?.ta}
            financialYear={selectedYear}
            month={selectedMonth}
          /> */}
          <Button
            className="left-btn btn-primary-submit-to-ca"
            onClick={deleteEmployee}
            disabled={empIds?.length <= 0}
            variant="success"
          >
            <FaTrash
              style={{
                marginRight: "0.5rem",
                marginTop: "-0.3rem",
                transform: "scale(1.2)",
                transformOrigin: "center",
                fontSize: "0.7rem",
              }}
            />
            Delete Selected
          </Button>
          <Button
            onClick={handelPrintEmpReport}
            variant="success btn-primary-submit-to-ca"
          >
            <BsPrinter
              style={{
                marginRight: "0.5rem",
                transform: "scale(1.2)",
                transformOrigin: "center",
              }}
            />
            Employee Report
          </Button>
        </div>
        <div className="table-container">
          <Form27EQTable
            data={filtered27EQInfo}
            onEdit={handleEdit}
            // onDelete={deleteEmployee}
            activePage={activePage}
            limit={limit}
            setEmpIds={setEmpIds}
            selectedMonth={selectedMonth}
            isDataSendToCA={isDataSendToCA}
            empIds={empIds}
          />
        </div>
        <Row className="mt-3 mb-2">
          <Col
            xs={12}
            className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
          >
            {/* Records per page */}
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filtered27EQInfo.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1); // Reset to first page on limit change
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>
                {`Page ${activePage} of ${maxPage}`}
              </Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>
          </Col>
        </Row>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-2 mt-3 gap-2">
          <div className="align-self-start"></div>
          <div className="d-flex flex-column flex-md-row gap-2">
            <Button
              className="btn-primary-submit-to-ca "
              // onClick={() => showFileDialog()}
              onClick={() => downloadTemplateFile()}
              disabled={isDataSendToCA}
            >
              {downloadingEmpLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Downloading...
                </>
              ) : (
                <>
                  <FaCloudDownloadAlt
                    style={{ fontSize: "1.2rem", marginRight: ".2rem" }}
                  ></FaCloudDownloadAlt>
                  <>Download Party</>
                </>
              )}
            </Button>
            <Button
              className="btn-primary-submit-to-ca "
              // onClick={() => showFileDialog()}
              onClick={() => uploadTemplateFile()}
              disabled={isDataSendToCA}
            >
              {uploadingEmpLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Uploading...
                </>
              ) : (
                <>
                  <FaCloudUploadAlt
                    style={{ fontSize: "1.2rem", marginRight: ".2rem" }}
                  ></FaCloudUploadAlt>
                  <>Upload Party</>
                  <span title="Excel must have three columns: Sr.No, Name and Pan in the first row">
                    ℹ️
                  </span>
                </>
              )}
            </Button>

            <input
              id="fileInput"
              type="file"
              accept=".xlsx"
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
            <Button
              className="btn-primary-submit-to-ca "
              onClick={() => {
                showChallan();
              }}
            >
              <BsPlus style={{ fontSize: "1.5rem" }} />
              Add Challan Info
            </Button>
            <Button
              className="btn-primary-submit-to-ca "
              onClick={() => {
                submitToCA();
              }}
              disabled={isDataSendToCA}
            >
              {submitToCALoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Submiting Data...
                </>
              ) : (
                <>
                  <BsSend
                    style={{
                      color: "#2c3e50",
                      fontSize: "1.3rem",
                      paddingRight: "5px",
                    }}
                  />
                  Submit to CA
                </>
              )}
            </Button>
            <Button
              onClick={() => {
                handleAdd();
              }}
              disabled={isDataSendToCA}
            >
              <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
              Add Info
            </Button>
            <Button
              onClick={() => {
                getLastMonthData();
              }}
              disabled={isDataSendToCA}
            >
              {copyDataloading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Copying Data...
                </>
              ) : (
                <>
                  <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                  Copy Last Month Data
                </>
              )}
            </Button>

            <Button
              onClick={() => {
                navigate("/client-dashboard");
              }}
            >
              <BsX
                style={{ color: "red", fontSize: "1.5rem", fontWeight: 600 }}
              />
              Close
            </Button>
          </div>
          {showChallanInfo ? (
            <ChallanDetail
              show={showChallanInfo}
              onHide={() => {
                hideChallan();
              }}
              formName="form27eq"
              selectedFYearId={selectedFYearId}
              selectedMonth={selectedMonth}
              challanAmt={challanAmount}
            />
          ) : null}
        </div>

        {/* Modal */}
        <Modal show={showModal} onHide={closeModal} size="lg" scrollable>
          <Modal.Header closeButton>
            <Modal.Title className="text-primary ">Party Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="g-3">
                {form27EQFields.map((field, index) => (
                  <React.Fragment key={index}>
                    <Col md={4}>
                      <Form.Group controlId={`field${index}`}>
                        <Form.Label className="textbox-label">
                          {index === 0 || index === 1 ? (
                            <>
                              {field.label}
                              <span style={{ color: "red" }}>*</span>
                            </>
                          ) : (
                            field.label
                          )}
                        </Form.Label>

                        {/* Conditionally render a date picker if index is 6 or 15 */}
                        {index === 6 || index === 15 ? (
                          <Form.Control
                            type="date"
                            name={field.key}
                            value={
                              formData[field.key]
                                ? moment(formData[field.key]).format(
                                    "YYYY-MM-DD"
                                  )
                                : ""
                            }
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                [field.key]: e.target.value,
                              }))
                            }
                          />
                        ) : (
                          <Form.Control
                            type="text"
                            name={field.key}
                            value={formData[field.key]}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                [field.key]: e.target.value,
                              }))
                            }
                          />
                        )}
                      </Form.Group>
                    </Col>

                    {(index + 1) % 6 === 0 && (
                      <Col md={12}>
                        <hr />
                      </Col>
                    )}
                  </React.Fragment>
                ))}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center text-md-end mb-2">
              <Button
                style={{ width: "200px" }}
                className="me-md-3"
                variant="primary"
                onClick={() => {
                  save27EQInfo(
                    editingIndex !== null ? "updateInfo" : "addInfo"
                  );
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Update" : "Add"}
                  </>
                )}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default Form27EQ;
